export const defaultWidth = 700;